// Centralized app configuration.
// The Winter Protocol APK is hosted directly on this website and served from /public.
export const APP_DOWNLOAD_URL = "/winter-protocol.apk";
export const APP_VERSION = "1.0.11";
export const APP_SIZE = "106 MB";

export const BRAND = {
  name: "WINTER PROTOCOL",
  tagline: "Invest Smarter. Earn Together. Build the Future.",
  descriptor: "AI-Powered Wealth Ecosystem",
};
